import styled from "styled-components";

export const SliderContainer = styled.div`
  padding: 10px;
`;

export const SliderTrack = styled.div`
  position: relative;
  height: 8px;
  width: 60%;
  max-width: auto;
  background: var(--border-color);
  border-radius: 4px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  /* width: ${props => props.size === 'small' ? '150px' : props.size === 'large' ? '300px' : '200px'}; */
`;

export const SliderRail = styled.div`
  position: absolute;
  height: 100%;
  background: ${props => props.disabled ? 'var(--border-color)' : props.customColor || 'var(--theme-color-primary)'};
  border-radius: 4px;
  width: ${props => props.percentage}%;
`;

export const SliderThumb = styled.div`
  position: absolute;
  width: ${(props) => props.size === 'small' ? '6px' : props.size === 'large' ? '22px' : '12px'};
  height:  ${(props) => props.size === 'small' ? '6px' : props.size === 'large' ? '22px' : '12px'};
  background: ${props => props.disabled ? 'var(--border-color)' : props.customColor || 'var(--theme-color-primary)'};
  border-radius: 50%;
  top: 50%;

  transform: translate(-50%, -50%);
  left: ${props => props.percentage}%;

  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: box-shadow 0.2s;
  
  &:hover {
    box-shadow: ${props => props.disabled ? 'none' : `0 0 0 6px color-mix(in srgb, ${props.customColor || 'var(--theme-color-primary)'}, transparent 80%)`};
  }

  &:active {
    box-shadow: ${props => props.disabled ? 'none' : `0 0 0 8px color-mix(in srgb, ${props.customColor || 'var(--theme-color-primary)'}, transparent 80%)`};
  }
`;

export const Mark = styled.div`
  position: absolute;
  width: 6px;
  height: 6px;
  background: ${props => props.$active ? (props.customColor || 'var(--theme-color-primary)') : 'var(--border-color)'};
  border-radius: 50%;
  top: 50%;

  transform: translate(-50%, -50%);
  left: ${props => props.percentage}%;

`;

export const MarkLabel = styled.div`
  position: absolute;
  top: 20px;
  left: ${props => props.percentage}%;
  transform: translateX(-50%);
  font-size: 6px;
  color: var(--text-color-secondary);

`;

export const ValueLabel = styled.div`
  position: absolute;
  top: -35px;
  left: ${props => props.percentage}%;
  transform: translateX(-50%);
  background: rgb(0, 0, 0, 0.8);
  color: white;
  padding: 2px 4px;
  border-radius: 4px;
  font-size: 11px;
  display: ${props => props.$show ? 'block' : 'none'};

  .dark-mode & {
    background: rgb(255, 255, 255, 0.15);
  }
`;

export const PercentageDisplay = styled.div`
  position: absolute;
  right: -43px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: var(--text-color-secondary);
  font-weight: 500;
  min-width: 35px;
  text-align: left;
`;